module.exports = __webpack_public_path__ + "static/extra_2-f1affe5e1d50c1a696fa28e0e59fc57e.jpg";